import { render, staticRenderFns } from "./FutureTrading.vue?vue&type=template&id=5cdf15d8&scoped=true&"
import script from "./FutureTrading.vue?vue&type=script&lang=js&"
export * from "./FutureTrading.vue?vue&type=script&lang=js&"
import style0 from "./FutureTrading.vue?vue&type=style&index=0&id=5cdf15d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdf15d8",
  null
  
)

export default component.exports